import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.human.reviews');
import { workspaceDateTime } from "src/libs/portal/review/workspace-ui";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-human-reviews',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.human.reviews/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  font-family: Pretendard, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #242824;
}

* {
  box-sizing: border-box;
}

button,
input,
select {
  font: inherit;
}

button,
a {
  -webkit-tap-highlight-color: transparent;
}

.review-workbench {
  --review-accent: #e4552e;
  --review-accent-dark: #c94827;
  --review-ink: #252925;
  --review-muted: #737a73;
  --review-canvas: var(--ro-canvas, #fafbf8);
  --review-soft: #fafbf8;
  --review-line: #e2e5df;
  --review-line-strong: #d5d9d2;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  background: var(--review-canvas);
}

.review-workbench__header {
  display: flex;
  min-height: 102px;
  flex: 0 0 102px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 18px 34px;
  border-bottom: 1px solid var(--review-line);
  background: #fff;
}

.review-workbench__header-copy {
  min-width: 0;
}

.review-workbench__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.review-workbench__title-row h1 {
  margin: 0;
}

.review-workbench__assigned {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  color: #53604e;
  background: #edf2e9;
  font-size: 12px;
  font-weight: 700;
}

.review-workbench__header-copy > p {
  margin: 8px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
}

.review-workbench__header-status {
  display: flex;
  align-items: center;
  gap: 18px;
  color: #7e857d;
  font-size: 12px;
}

.review-workbench__header-status span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #5f7057;
  font-weight: 700;
}

.review-workbench__header-status i {
  color: #4e8b4a;
  font-size: 12px;
}

.review-workbench__header-status strong {
  padding-left: 18px;
  border-left: 1px solid var(--review-line);
  color: #717771;
  font-weight: 700;
}

.review-workbench__body {
  display: grid;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  grid-template-columns: minmax(330px, 380px) minmax(0, 1fr);
  overflow: hidden;
  background: var(--review-canvas);
}

.review-workbench__zero {
  display: grid;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  place-items: center;
  padding: 40px;
  background: var(--review-canvas);
}

.review-workbench__zero-content {
  display: grid;
  width: min(520px, 100%);
  justify-items: center;
  gap: 10px;
  color: #868d86;
  text-align: center;
}

.review-workbench__zero-icon {
  display: grid;
  width: 48px;
  height: 48px;
  margin-bottom: 3px;
  place-items: center;
  border-radius: 13px;
  color: #72806d;
  background: #e9eee6;
  font-size: 17px;
}

.review-workbench__zero-content strong {
  color: #4e564e;
  font-size: 13px;
  font-weight: 700;
}

.review-workbench__zero-content p {
  margin: 0;
  color: #899089;
  font-size: 12px;
  line-height: 1.55;
}

.review-workbench__zero-action {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
  padding: 0 17px;
  border: 1px solid var(--review-accent-dark);
  border-radius: 8px;
  color: #fff;
  background: var(--review-accent);
  box-shadow: 0 8px 20px rgba(156, 57, 30, 0.14);
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
}

.review-workbench__zero-action:hover {
  background: var(--review-accent-dark);
  box-shadow: 0 10px 24px rgba(156, 57, 30, 0.2);
}

.review-workbench__zero-projects {
  width: 100%;
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.review-workbench__zero-project {
  display: grid;
  min-height: 64px;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  color: var(--review-ink);
  background: #fff;
  border: 1px solid var(--review-line-strong);
  border-radius: 10px;
  text-align: left;
  text-decoration: none;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.review-workbench__zero-project:hover,
.review-workbench__zero-project:focus-visible {
  border-color: #8ca094;
  background: #fbfcfa;
  box-shadow: 0 8px 20px rgba(50, 67, 58, 0.08);
  outline: 0;
}

.review-workbench__zero-project-icon {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  color: #fff;
  background: #3c7062;
  border-radius: 9px;
  font-size: 12px;
}

.review-workbench__zero-project-copy {
  min-width: 0;
}

.review-workbench__zero-project-copy strong,
.review-workbench__zero-project-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-workbench__zero-project-copy strong {
  color: #36403a;
  font-size: 12px;
  font-weight: 700;
}

.review-workbench__zero-project-copy small {
  margin-top: 4px;
  color: #818982;
  font-size: 12px;
  font-weight: 600;
}

.review-workbench__zero-project-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #3d6e61;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.qa-review-project-main {
  background: var(--review-canvas);
}

.qa-review-project-ledger {
  background: #fff;
  border: 1px solid var(--review-line);
}

.qa-review-project-ledger__header {
  border-bottom: 1px solid var(--review-line);
}

.qa-review-project-ledger__header > div {
  min-width: 0;
}

.qa-review-project-ledger__header > div > span {
  color: var(--review-accent);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.qa-review-project-ledger__header h2 {
  margin: 6px 0 0;
  color: var(--review-ink);
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.qa-review-project-ledger__header p {
  margin: 7px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.qa-review-project-search {
  color: var(--review-muted);
  background: #fff;
  border: 1px solid var(--review-line-strong);
}

.qa-review-project-search:focus-within {
  border-color: #83976a;
}

.qa-review-project-search input {
  min-width: 0;
  flex: 1;
  padding: 0;
  color: var(--review-ink);
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 600;
}

.qa-review-project-search button {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: var(--review-muted);
  background: #f1f3ef;
  border: 0;
  cursor: pointer;
}

.qa-review-project-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.qa-review-project-table thead {
  background: #fafbf8;
  border-bottom: 1px solid var(--review-line);
  box-shadow: none !important;
}

.qa-review-project-table th {
  height: 48px;
  padding: 0 13px;
  color: #858b83;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}

.qa-review-project-table th:first-child,
.qa-review-project-table td:first-child {
  width: 22%;
  padding-left: 24px;
}

.qa-review-project-table th:nth-child(2) {
  width: 16%;
}

.qa-review-project-table th:nth-child(3) {
  width: 18%;
}

.qa-review-project-table th:nth-child(4) {
  width: 9%;
}

.qa-review-project-table th:nth-child(5) {
  width: 11%;
}

.qa-review-project-table th:nth-child(6) {
  width: 12%;
}

.qa-review-project-table th:nth-child(7) {
  width: 12%;
}

.qa-review-project-table th:last-child,
.qa-review-project-table td:last-child {
  padding-right: 24px;
  text-align: right;
}

.qa-review-project-table tbody tr {
  height: 104px;
  background: #fff;
  border-bottom: 1px solid #e8ebe5;
  box-shadow: none !important;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.qa-review-project-table tbody tr:hover {
  background: #fbfcf9;
  box-shadow: inset 3px 0 0 var(--review-accent) !important;
}

.qa-review-project-table tbody tr:last-child {
  border-bottom: 0 !important;
  box-shadow: none !important;
}

.qa-review-project-table td {
  padding: 16px 13px;
  vertical-align: middle;
}

.qa-review-project-cell {
  display: grid;
  min-width: 0;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
}

.qa-review-project-cell > span {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #655781;
  background: #f0edf6;
  border: 1px solid #ddd6e8;
  border-radius: 10px;
  font-size: 13px;
}

.qa-review-project-cell > div,
.qa-review-result-cell,
.qa-review-survey-cell {
  min-width: 0;
}

.qa-review-project-cell strong,
.qa-review-project-cell small,
.qa-review-result-cell strong,
.qa-review-result-cell small,
.qa-review-survey-cell strong,
.qa-review-survey-cell small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-review-project-cell strong {
  color: #2b302a;
  font-size: 12px;
  font-weight: 700;
}

.qa-review-project-cell small,
.qa-review-result-cell small,
.qa-review-survey-cell small {
  margin-top: 6px;
  color: #929990;
  font-size: 12px;
  font-weight: 600;
}

.qa-review-result-cell strong,
.qa-review-survey-cell strong {
  color: #4c554f;
  font-size: 12px;
  font-weight: 700;
}

.qa-review-result-cell.ready strong {
  color: #2e745d;
}

.qa-review-result-cell.empty strong,
.qa-review-result-cell.missing strong,
.qa-review-result-cell.invalid strong {
  color: #a15c43;
}

.qa-review-target {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  padding: 0 9px;
  color: #6b6043;
  background: #f7f3e8;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.qa-review-project-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #737a73;
  font-size: 12px;
  font-weight: 700;
}

.qa-review-project-status i {
  width: 7px;
  height: 7px;
  background: #9da39b;
  border-radius: 999px;
}

.qa-review-project-status.is-ready {
  color: #2e745d;
}

.qa-review-project-status.is-ready i {
  background: #2e745d;
}

.qa-review-project-status.is-progress {
  color: #7a6237;
}

.qa-review-project-status.is-progress i {
  background: #bd8b35;
}

.qa-review-project-status.is-complete {
  color: #655781;
}

.qa-review-project-status.is-complete i {
  background: #655781;
}

.qa-review-updated {
  color: #596058;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.qa-review-project-action {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  color: #fff;
  background: #343934;
  border: 0;
  white-space: nowrap;
  cursor: pointer;
}

.qa-review-project-action:hover:not(:disabled),
.qa-review-project-action:focus-visible:not(:disabled) {
  background: var(--review-accent);
  outline: 0;
}

.qa-review-project-action:disabled {
  color: #959c96;
  background: #ecefeb;
  cursor: not-allowed;
}

.qa-review-project-error,
.qa-review-project-empty {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #8e4c3b;
  font-size: 12px;
}

.qa-review-project-error button,
.qa-review-project-empty button,
.qa-review-project-empty a {
  min-height: 34px;
  padding: 0 11px;
  color: #fff;
  background: #343934;
  border: 0;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

.qa-review-project-empty {
  flex-direction: column;
  color: #858c85;
  text-align: center;
}

.qa-review-project-empty > span {
  font-size: 18px;
}

.qa-review-project-empty strong {
  color: #4f574e;
  font-size: 13px;
}

.qa-review-project-empty p {
  margin: 0;
}

.qa-review-project-ledger__footer {
  display: grid;
  min-height: 58px;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 20px;
  padding: 0 24px;
  color: #8c938b;
  background: #fafbf8;
  border-top: 1px solid var(--review-line);
  font-size: 12px;
}

.qa-review-project-ledger__footer strong {
  color: #555e56;
  font-weight: 700;
}

.qa-review-project-ledger__footer > span {
  justify-self: end;
  text-align: right;
}

.qa-review-project-pagination {
  grid-column: 2;
}

.qa-review-project-pagination button {
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  place-items: center;
  border: 1px solid #dfe3dc;
  outline: 0;
  color: #747b74;
  background: #fff;
  box-shadow: none;
  cursor: pointer;
}

.qa-review-project-pagination button:hover:not(:disabled),
.qa-review-project-pagination button:focus-visible {
  border-color: #9daa9e;
  color: #41604f;
  background: #f3f7f3;
}

.qa-review-project-pagination button.is-active {
  border-color: var(--review-accent);
  color: var(--review-accent-dark);
  background: #fff5f0;
}

.qa-review-project-pagination button:disabled {
  color: #c7cbc5;
  background: #f4f5f2;
  cursor: default;
}

@media (max-width: 980px) {
  .qa-review-project-cards {
    background: #f6f8f5;
  }
  .qa-review-project-ledger__footer {
    grid-template-columns: 1fr auto;
    padding-block: 12px;
  }
  .qa-review-project-ledger__footer > span {
    display: none;
  }
  .qa-review-project-cards article {
    padding: 15px;
    background: #fff;
    border: 1px solid var(--review-line);
    border-radius: 10px;
  }
  .qa-review-project-cards header {
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr) auto;
    align-items: center;
    gap: 10px;
  }
  .qa-review-project-cards header > span {
    display: grid;
    width: 36px;
    height: 36px;
    place-items: center;
    color: #655781;
    background: #f0edf6;
    border-radius: 9px;
  }
  .qa-review-project-cards header strong,
  .qa-review-project-cards header small {
    display: block;
  }
  .qa-review-project-cards header strong {
    color: #303630;
    font-size: 12px;
  }
  .qa-review-project-cards header small {
    margin-top: 4px;
    color: #8c938c;
    font-size: 12px;
  }
  .qa-review-project-cards header em {
    color: #6f776f;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
  }
  .qa-review-project-cards dl {
    display: grid;
    gap: 8px;
    margin: 14px 0;
  }
  .qa-review-project-cards dl div {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }
  .qa-review-project-cards dt,
  .qa-review-project-cards dd {
    margin: 0;
    font-size: 12px;
  }
  .qa-review-project-cards dt {
    color: #8a928a;
  }
  .qa-review-project-cards dd {
    color: #4d564f;
    font-weight: 700;
    text-align: right;
  }
  .qa-review-project-cards article > button {
    width: 100%;
    min-height: 38px;
    color: #fff;
    background: #343934;
    border: 0;
  }
}
@media (max-width: 560px) {
  .review-workbench__zero {
    padding: 24px 16px;
  }
  .review-workbench__zero-project {
    grid-template-columns: 36px minmax(0, 1fr);
  }
  .review-workbench__zero-project-action {
    grid-column: 2;
  }
}
.review-assignment-page {
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 30px 34px 44px;
  background: var(--review-canvas);
  scrollbar-color: #c5cac3 transparent;
  scrollbar-width: thin;
}

.review-assignment-list {
  width: min(1380px, 100%);
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid var(--review-line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(45, 52, 43, 0.035);
}

.review-assignment-list__header {
  display: flex;
  min-height: 108px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 28px;
  border-bottom: 1px solid var(--review-line);
}

.review-assignment-list__header > div > span {
  display: block;
  margin-bottom: 7px;
  color: var(--review-accent);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.review-assignment-list__header h2 {
  margin: 0;
  color: #292e29;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.review-assignment-list__header p {
  margin: 7px 0 0;
  color: #858c85;
  font-size: 12px;
  line-height: 1.5;
}

.review-assignment-list__header > strong {
  display: inline-flex;
  min-height: 30px;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 11px;
  border-radius: 999px;
  color: #5c6857;
  background: #eef2eb;
  font-size: 12px;
  font-weight: 700;
}

.review-assignment-table__head,
.review-assignment-row {
  display: grid;
  grid-template-columns: minmax(280px, 1.4fr) 100px 100px minmax(170px, 0.7fr) 140px;
  align-items: center;
  column-gap: 24px;
}

.review-assignment-table__head {
  min-height: 44px;
  padding: 0 28px;
  border-bottom: 1px solid var(--review-line);
  color: #8b928b;
  background: #fafbf8;
  font-size: 12px;
  font-weight: 700;
}

.review-assignment-table__head span:last-child {
  text-align: right;
}

.review-assignment-row {
  min-height: 112px;
  padding: 20px 28px;
  border-bottom: 1px solid var(--review-line);
  transition: background 0.16s ease;
}

.review-assignment-row:last-child {
  border-bottom: 0;
}

.review-assignment-row:hover {
  background: #fdfefc;
}

.review-assignment-row__project {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 13px;
}

.review-assignment-row__icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 10px;
  color: #6c7c65;
  background: #edf2e9;
  font-size: 14px;
}

.review-assignment-row__project h3 {
  overflow: hidden;
  margin: 0;
  color: #2a2f2a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-assignment-row__project p {
  overflow: hidden;
  margin: 7px 0 0;
  color: #909690;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-assignment-row__count,
.review-assignment-row__status {
  display: grid;
  gap: 7px;
}

.review-assignment-row__count small,
.review-assignment-row__status small,
.review-assignment-row__progress small {
  display: none;
  color: #909790;
  font-size: 12px;
  font-weight: 700;
}

.review-assignment-row__count strong {
  color: #4e564e;
  font-size: 12px;
  font-weight: 700;
}

.review-assignment-row__progress {
  min-width: 0;
}

.review-assignment-row__progress > div:first-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.review-assignment-row__progress strong {
  color: var(--review-accent);
  font-size: 13px;
  font-weight: 700;
}

.review-assignment-row__progress .review-progress {
  height: 4px;
  margin-top: 8px;
}

.review-assignment-row__progress > span {
  display: block;
  margin-top: 6px;
  color: #929892;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.review-assignment-row__action {
  display: flex;
  justify-content: flex-end;
}

.review-assignment-action {
  display: inline-flex;
  min-width: 122px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 15px;
  border: 1px solid var(--review-accent-dark);
  border-radius: 7px;
  color: #fff;
  background: var(--review-accent);
  box-shadow: 0 7px 18px rgba(156, 57, 30, 0.14);
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
  transition: background 0.16s ease, box-shadow 0.16s ease;
}

.review-assignment-action:hover {
  background: var(--review-accent-dark);
  box-shadow: 0 9px 22px rgba(156, 57, 30, 0.2);
}

.review-assignment-action.is-disabled {
  border-color: #dce1da;
  color: #858d85;
  background: #eef1ed;
  box-shadow: none;
}

.review-assignment-action:focus-visible {
  outline: 3px solid rgba(228, 85, 46, 0.18);
  outline-offset: 2px;
}

.review-queue {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid var(--review-line);
  background: var(--review-soft);
}

.review-queue__header {
  display: grid;
  gap: 17px;
  padding: 20px 20px 0;
  border-bottom: 1px solid var(--review-line);
  background: var(--review-soft);
}

.review-queue__heading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.review-queue__heading h2 {
  margin: 0;
  color: #2c302c;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.review-queue__heading > span {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border-radius: 999px;
  color: #687067;
  background: #eef0ec;
  font-size: 12px;
  font-weight: 700;
}

.review-queue__filters {
  display: flex;
  gap: 20px;
  overflow-x: auto;
}

.review-queue__filters button {
  position: relative;
  display: inline-flex;
  min-height: 38px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0 0 12px;
  border: 0;
  color: #858b84;
  background: transparent;
  cursor: pointer;
}

.review-queue__filters button::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: var(--review-accent);
  content: "";
  opacity: 0;
}

.review-queue__filters button.is-active {
  color: var(--review-accent);
}

.review-queue__filters button.is-active::after {
  opacity: 1;
}

.review-queue__filters em {
  display: inline-grid;
  min-width: 18px;
  height: 18px;
  place-items: center;
  padding: 0 5px;
  border-radius: 999px;
  color: inherit;
  background: #f1f2ef;
  font-size: 12px;
  font-style: normal;
}

.review-queue__filters button.is-active em {
  background: #fff0ea;
}

.review-queue__tools {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  gap: 8px;
  padding: 14px 14px 10px;
  background: var(--review-soft);
}

.review-queue__sort,
.review-queue__search {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 38px;
  align-items: center;
  border: 1px solid var(--review-line-strong);
  border-radius: 7px;
  color: #899088;
  background: #fff;
}

.review-queue__sort:focus-within,
.review-queue__search:focus-within {
  border-color: #9aa795;
  outline: 2px solid rgba(98, 117, 87, 0.13);
  outline-offset: 1px;
}

.review-queue__sort > i,
.review-queue__search > i {
  margin-left: 11px;
  font-size: 12px;
}

.review-queue__sort select,
.review-queue__search input {
  width: 100%;
  height: 36px;
  min-height: 0 !important;
  min-width: 0;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  color: #596059;
  background: transparent !important;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 600;
}

.review-queue__sort select:focus,
.review-queue__search input:focus,
.review-queue__sort select:focus-visible,
.review-queue__search input:focus-visible {
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.review-queue__sort select {
  padding: 0 7px;
  cursor: pointer;
}

.review-queue__search input {
  padding: 0 32px 0 9px;
}

.review-queue__search input::placeholder {
  color: #a4aaa3;
}

.review-queue__search button {
  position: absolute;
  right: 6px;
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border: 0;
  color: #929991;
  background: transparent;
  cursor: pointer;
}

.review-queue__scroll {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 2px 14px 20px;
  scrollbar-color: #c5cac3 transparent;
  scrollbar-width: thin;
}

.review-queue__group {
  margin-top: 14px;
}

.review-queue__group-heading {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 8px;
  padding: 0 3px;
}

.review-queue__group-heading h3 {
  margin: 0;
  color: #464c46;
  font-size: 12px;
  font-weight: 700;
}

.review-queue__group-heading span {
  color: #929891;
  font-size: 12px;
  font-weight: 700;
}

.review-queue__item {
  width: 100%;
  margin-top: 7px;
  padding: 14px 15px 13px;
  border: 1px solid #e1e5de;
  border-radius: 9px;
  color: inherit;
  background: #fff;
  box-shadow: none;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}

.review-queue__item:hover {
  border-color: #cdd3ca;
  background: #fdfefd;
}

.review-queue__item.is-active {
  border-color: #ef8b6d;
  background: #fff8f5;
  box-shadow: 0 0 0 1px rgba(228, 85, 46, 0.06);
}

.review-queue__item-top,
.review-queue__item-top > div,
.review-queue__item-meta,
.review-queue__item-progress {
  display: flex;
  align-items: center;
}

.review-queue__item-top {
  justify-content: space-between;
  gap: 10px;
}

.review-queue__item-top > div {
  min-width: 0;
  gap: 8px;
}

.review-queue__item-top > i {
  color: #c4c9c2;
  font-size: 12px;
}

.review-queue__item.is-active .review-queue__item-top > i {
  color: var(--review-accent);
}

.review-queue__item h4 {
  overflow: hidden;
  margin: 0;
  color: #2b302b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-queue__item > p {
  overflow: hidden;
  margin: 8px 0 0;
  color: #858b84;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-queue__item-meta {
  gap: 9px;
  margin-top: 12px;
  color: #7c837c;
  font-size: 12px;
}

.review-queue__item-meta > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.review-queue__item-meta strong {
  font-size: 12px;
  font-weight: 700;
}

.review-queue__item-progress {
  gap: 4px;
  margin-left: auto;
}

.review-queue__item-progress em {
  color: #a0a5a0;
  font-style: normal;
}

.review-queue__item-progress b {
  color: #4d554d;
  font-weight: 700;
}

.review-progress {
  width: 100%;
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7eae5;
}

.review-progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--review-accent);
}

.review-queue__item > .review-progress {
  height: 3px;
  margin-top: 9px;
}

.review-queue__footer {
  display: flex;
  min-height: 42px;
  flex: 0 0 42px;
  align-items: center;
  justify-content: space-between;
  padding: 0 17px;
  border-top: 1px solid var(--review-line);
  color: #8a918a;
  background: var(--review-soft);
  font-size: 12px;
  font-weight: 600;
}

.review-detail {
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  background: var(--review-canvas);
  scrollbar-color: #c5cac3 transparent;
  scrollbar-width: thin;
}

.review-detail__hero {
  display: grid;
  min-height: 210px;
  grid-template-columns: minmax(0, 1fr) minmax(310px, 39%);
  align-items: center;
  gap: 44px;
  padding: 32px 38px;
  border-bottom: 1px solid var(--review-line);
  background: #fff;
}

.review-status {
  display: inline-flex;
  width: fit-content;
  min-height: 23px;
  align-items: center;
  padding: 0 8px;
  border-radius: 5px;
  color: #7a5e25;
  background: #fbf1dc;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.review-status.is-progress {
  color: #356d96;
  background: #eaf3fa;
}

.review-status.is-complete {
  color: #39744d;
  background: #e9f4ec;
}

.review-detail__identity h2 {
  margin: 14px 0 0;
  color: #202420;
  font-size: clamp(24px, 2.2vw, 31px);
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1.2;
}

.review-detail__identity > p {
  margin: 9px 0 0;
  color: #6f766f;
  font-size: 12px;
  font-weight: 600;
}

.review-detail__identity > a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 14px;
  padding: 7px 9px;
  border: 1px solid var(--review-line);
  border-radius: 6px;
  color: #666e66;
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
}

.review-detail__identity > a:hover {
  border-color: #bdc4bb;
  color: #3e463e;
  background: #f8f9f6;
}

.review-detail__headline-metrics {
  display: grid;
  grid-template-columns: minmax(105px, 0.7fr) minmax(160px, 1fr);
  gap: 28px;
}

.review-detail__deadline,
.review-detail__completion {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
}

.review-detail__deadline {
  padding-right: 28px;
  border-right: 1px solid var(--review-line);
}

.review-detail__deadline small,
.review-detail__completion small {
  color: #858c85;
  font-size: 12px;
  font-weight: 700;
}

.review-detail__deadline strong,
.review-detail__completion strong {
  display: block;
  margin-top: 7px;
  color: var(--review-accent);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.035em;
  line-height: 1;
}

.review-detail__deadline > span,
.review-detail__completion > span {
  margin-top: 8px;
  color: #8a908a;
  font-size: 12px;
  font-weight: 600;
}

.review-detail__completion > div:first-child {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.review-detail__completion .review-progress {
  height: 6px;
  margin-top: 11px;
}

.review-detail__summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 30px 38px 32px;
  border-bottom: 1px solid var(--review-line);
  background: #fff;
}

.review-detail__summary-block {
  min-width: 0;
  padding-right: 34px;
}

.review-detail__summary-block + .review-detail__summary-block {
  padding-right: 0;
  padding-left: 34px;
  border-left: 1px solid var(--review-line);
}

.review-detail__summary h3,
.review-detail__guide h3 {
  margin: 0 0 20px;
  color: #303530;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.review-detail__summary dl {
  display: grid;
  gap: 13px;
  margin: 0;
}

.review-detail__summary dl > div {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.review-detail__summary dt {
  color: #919791;
  font-size: 12px;
  font-weight: 600;
}

.review-detail__summary dd {
  min-width: 0;
  margin: 0;
  color: #555d55;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.55;
}

.review-detail__summary dd a {
  color: #8b492f;
  text-decoration: none;
}

.review-detail__summary dd a:hover {
  color: var(--review-accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.review-detail__guide {
  padding: 28px 38px 32px;
  border-bottom: 1px solid var(--review-line);
  background: #fff;
}

.review-detail__guide ol {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.review-detail__guide li {
  position: relative;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 11px;
  min-width: 0;
  padding-right: 28px;
}

.review-detail__guide li:not(:last-child)::after {
  position: absolute;
  top: 14px;
  right: 12px;
  width: 18px;
  height: 1px;
  background: #d9ddd7;
  content: "";
}

.review-detail__guide li > span {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border: 1px solid #d1d6ce;
  border-radius: 999px;
  color: #515951;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

.review-detail__guide strong {
  display: block;
  color: #3a403a;
  font-size: 12px;
  font-weight: 700;
}

.review-detail__guide p {
  max-width: 25ch;
  margin: 6px 0 0;
  color: #858c85;
  font-size: 12px;
  line-height: 1.55;
}

.review-detail__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 26px 38px 38px;
  background: #fff;
}

.review-detail__notice {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 10px;
  color: #727a72;
}

.review-detail__notice > i {
  margin-top: 2px;
  color: #6d7b65;
  font-size: 12px;
}

.review-detail__notice p {
  display: grid;
  gap: 5px;
  margin: 0;
}

.review-detail__notice strong {
  color: #454c45;
  font-size: 12px;
  font-weight: 700;
}

.review-detail__notice span {
  font-size: 12px;
  line-height: 1.45;
}

.review-detail__actions > div:last-child {
  display: flex;
  flex: 0 0 auto;
  gap: 9px;
}

.review-detail__secondary,
.review-detail__primary,
.review-inbox__empty button {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 18px;
  border-radius: 7px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
}

.review-detail__secondary {
  min-width: 102px;
  border: 1px solid #d7dcd4;
  color: #596159;
  background: #fff;
}

.review-detail__secondary:hover {
  border-color: #bdc4ba;
  background: #f8f9f6;
}

.review-detail__primary {
  min-width: 154px;
  border: 1px solid var(--review-accent-dark);
  color: #fff;
  background: var(--review-accent);
  box-shadow: 0 8px 20px rgba(156, 57, 30, 0.16);
}

.review-detail__primary:hover {
  background: var(--review-accent-dark);
  box-shadow: 0 10px 24px rgba(156, 57, 30, 0.22);
}

.review-detail__primary.is-disabled {
  color: #8b938c;
  background: #eef1ed;
  border-color: #dce1da;
  box-shadow: none;
  cursor: not-allowed;
}

.review-inbox__empty {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  place-items: center;
  align-content: center;
  gap: 9px;
  padding: 40px;
  color: #868d86;
  background: #fafbf9;
  text-align: center;
}

.review-inbox__empty--queue {
  min-height: 230px;
  margin-top: 12px;
  padding: 24px;
  border: 1px dashed #d8ddd5;
  border-radius: 10px;
  background: #fff;
}

.review-inbox__empty-icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 12px;
  color: #7d8978;
  background: #edf1ea;
  font-size: 15px;
}

.review-inbox__empty strong,
.review-detail--empty > strong {
  color: #505850;
  font-size: 12px;
  font-weight: 700;
}

.review-inbox__empty p,
.review-detail--empty > p {
  margin: 0;
  color: #899089;
  font-size: 12px;
}

.review-inbox__empty button {
  margin-top: 5px;
  border: 1px solid #d6dbd3;
  color: #555d55;
  background: #fff;
  cursor: pointer;
}

.review-detail--empty {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 9px;
  text-align: center;
}

.is-urgent {
  color: #db4f2a !important;
}

.is-near {
  color: #a56b20 !important;
}

.is-safe {
  color: #657064 !important;
}

.is-complete {
  color: #39744d !important;
}

.review-queue button:focus-visible,
.review-queue input:focus-visible,
.review-queue select:focus-visible,
.review-detail a:focus-visible,
.review-workbench__zero-action:focus-visible,
.review-inbox__empty button:focus-visible {
  outline: 3px solid rgba(228, 85, 46, 0.18);
  outline-offset: 2px;
}

@media (max-width: 1180px) {
  .review-assignment-table__head,
  .review-assignment-row {
    grid-template-columns: minmax(240px, 1.2fr) 80px 90px minmax(150px, 0.7fr) 126px;
    column-gap: 18px;
  }
  .review-workbench__body {
    grid-template-columns: minmax(310px, 340px) minmax(0, 1fr);
  }
  .review-detail__hero {
    grid-template-columns: minmax(0, 1fr) minmax(270px, 42%);
    gap: 28px;
    padding-inline: 30px;
  }
  .review-detail__summary,
  .review-detail__guide,
  .review-detail__actions {
    padding-inline: 30px;
  }
  .review-detail__summary dl > div {
    grid-template-columns: 74px minmax(0, 1fr);
  }
}
@media (max-width: 980px) {
  .review-workbench {
    overflow-y: auto;
  }
  .review-workbench__header {
    min-height: 92px;
    flex: 0 0 auto;
    padding-inline: 24px;
  }
  .review-workbench__body {
    display: block;
    overflow: visible;
  }
  .review-assignment-page {
    overflow: visible;
    padding: 24px;
  }
  .review-assignment-table__head,
  .review-assignment-row {
    grid-template-columns: minmax(220px, 1.2fr) 74px 86px minmax(135px, 0.7fr) 118px;
    column-gap: 14px;
  }
  .review-queue {
    min-height: 470px;
    max-height: 55vh;
    border-right: 0;
    border-bottom: 1px solid var(--review-line);
  }
  .review-detail {
    overflow: visible;
  }
}
@media (max-width: 700px) {
  .review-workbench__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    padding: 18px;
  }
  .review-workbench__header-status {
    width: 100%;
    justify-content: space-between;
  }
  .review-workbench__header-status strong {
    padding-left: 0;
    border-left: 0;
  }
  .review-workbench__zero {
    min-height: 420px;
    padding: 28px 20px;
  }
  .review-assignment-page {
    padding: 18px;
  }
  .review-assignment-list__header {
    min-height: 0;
    padding: 21px 20px;
  }
  .review-assignment-table__head {
    display: none;
  }
  .review-assignment-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 20px;
    padding: 20px;
  }
  .review-assignment-row__project {
    grid-column: 1/-1;
  }
  .review-assignment-row__count small,
  .review-assignment-row__status small,
  .review-assignment-row__progress small {
    display: block;
  }
  .review-assignment-row__progress {
    grid-column: 1/-1;
  }
  .review-assignment-row__progress > div:first-child {
    justify-content: space-between;
  }
  .review-assignment-row__progress > span {
    text-align: left;
  }
  .review-assignment-row__action {
    grid-column: 1/-1;
    justify-content: stretch;
  }
  .review-assignment-action {
    width: 100%;
  }
  .review-queue__header {
    padding-inline: 16px;
  }
  .review-queue__tools {
    grid-template-columns: 1fr;
    padding-inline: 10px;
  }
  .review-queue__scroll {
    padding-inline: 10px;
  }
  .review-detail__hero {
    min-height: 0;
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 28px 20px;
  }
  .review-detail__headline-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .review-detail__summary {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 26px 20px;
  }
  .review-detail__summary-block,
  .review-detail__summary-block + .review-detail__summary-block {
    padding: 0;
    border-left: 0;
  }
  .review-detail__summary-block + .review-detail__summary-block {
    padding-top: 26px;
    border-top: 1px solid var(--review-line);
  }
  .review-detail__guide {
    padding: 26px 20px;
  }
  .review-detail__guide ol {
    grid-template-columns: 1fr;
    gap: 22px;
  }
  .review-detail__guide li {
    padding-right: 0;
  }
  .review-detail__guide li:not(:last-child)::after {
    display: none;
  }
  .review-detail__actions {
    align-items: stretch;
    flex-direction: column;
    padding: 24px 20px 32px;
  }
  .review-detail__actions > div:last-child {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .review-detail__secondary,
  .review-detail__primary {
    min-width: 0;
  }
}`],
})
export class PageHumanReviewsComponent implements OnInit {
    public filter: string = '전체';
    public keyword: string = '';
    public sortMode: string = '마감 임박 순';
    public viewMode: 'list' | 'detail' = 'list';
    public selectedTaskId: string = '';
    public filters: string[] = ['전체', '대기', '검수 중', '제출 완료'];
    public tasks: any[] = [];
    public projects: any[] = [];
    public reviewProjects: any[] = [];
    public reviewProjectPage: number = 1;
    public readonly reviewProjectPageSize: number = 10;
    public reviewProjectLoadingId: string = '';
    public reviewProjectError: string = '';
    public uiLoading: boolean = true;
    public loadError: string = '';
    private readonly qaReviewTaskUrl: string = '/api/v1/review-workspace/qa-review-task';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadWorkspaceTasks();
        if (this.isAdmin() && !this.loadError) await this.loadQaReviewProjects();
        this.uiLoading = false;
        this.restoreRouteState();
        this.ensureSelection();
        await this.service.render();
    }

    private async loadWorkspaceTasks() {
        try {
            const response = await fetch('/api/v1/review-workspace/state', {
                method: 'GET',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, '검수 작업을 불러오지 못했습니다.'));
            const state = this.unwrapState(payload);
            if (!state || !Array.isArray(state.tasks)) throw new Error('검수 작업 응답 형식이 올바르지 않습니다.');
            const projects = Array.isArray(state.projects) ? state.projects : [];
            const evaluations = state.evaluations && typeof state.evaluations === 'object' ? state.evaluations : {};
            this.projects = projects;
            this.tasks = state.tasks
                .filter((task: any) => String(task && task.kind || '').toLowerCase() === 'qa')
                .map((task: any) => this.normalizeTask(task, projects, evaluations[String(task.id || '')]));
            this.loadError = '';
            return true;
        } catch (error) {
            this.tasks = [];
            this.projects = [];
            this.loadError = error instanceof Error ? error.message : 'QA 검수 작업을 불러오지 못했습니다.';
            return false;
        }
    }

    public async reloadWorkspaceTasks() {
        this.uiLoading = true;
        await this.service.render();
        await this.loadWorkspaceTasks();
        if (this.isAdmin() && !this.loadError) await this.loadQaReviewProjects();
        this.uiLoading = false;
        this.viewMode = 'list';
        this.ensureSelection();
        await this.service.render();
    }

    private normalizeTask(task: any, projects: any[], evaluation: any) {
        const projectId = String(task.projectId || task.project_id || '');
        const project = projects.find((item: any) => String(item && (item.id || item.projectId || item.project_id) || '') === projectId) || {};
        const samples = Array.isArray(task.samples) ? task.samples : [];
        const total = Number(task.total ?? task.sampleCount ?? task.sample_count ?? samples.length) || 0;
        const submitted = !!(evaluation && (evaluation.submitted === true || evaluation.submitted_at || evaluation.submittedAt || evaluation.recorded_at || evaluation.task_id));
        const completed = submitted ? total : (Number(task.completed ?? task.completedCount ?? task.completed_count) || 0);
        const survey = String(task.survey || task.surveyName || task.survey_name || '검수 설문지');
        const surveyVersion = String(task.surveyVersion || task.survey_version || '');
        return Object.assign({}, task, {
            id: String(task.id || ''),
            projectId: projectId,
            projectName: this.projectName(task, project, projectId),
            round: Number(task.round) || this.roundFromId(task.id),
            dataset: String(task.title || task.dataset || 'QA 검수 작업'),
            created: this.dateTimeLabel(task.created || task.createdAt || task.created_at),
            status: submitted ? '제출 완료' : this.statusLabel(task.status),
            assignmentPending: task.assignmentPending === true,
            qaCount: Number(task.qaCount ?? task.qa_count ?? total) || total,
            kgCount: Number(task.kgCount ?? task.kg_count) || 0,
            sampleCount: total,
            completedCount: completed,
            survey: this.versionedLabel(survey, surveyVersion),
            reviewer: String(task.reviewer || task.assignee || task.assigneeName || task.assignee_name || '검수 담당자'),
            assigneeId: String(task.assigneeId || task.assignee_id || ''),
            assigneeEmail: String(task.assigneeEmail || task.assignee_email || ''),
            due: this.dateLabel(task.due || task.dueAt || task.due_at)
        });
    }

    private projectName(task: any, project: any, projectId: string) {
        if (typeof task.project === 'string' && task.project.trim()) return task.project;
        return String(task.projectName || task.project_name || project.name || project.title || projectId || '검수 프로젝트');
    }

    private roundFromId(id: any) {
        const match = String(id || '').match(/-R(\d+)(?:-A[A-F0-9]+)?$/i);
        return match ? Number(match[1]) : 1;
    }

    private statusLabel(status: any) {
        const value = String(status || '').trim();
        const key = value.toLowerCase().replace(/[\s_-]+/g, '');
        if (value === '제출 완료' || value === '검수 완료' || ['submitted', 'completed', 'complete', 'done', 'approved'].includes(key)) return '제출 완료';
        if (value === '검수 중' || ['inprogress', 'progress', 'reviewing', 'started'].includes(key)) return '검수 중';
        return value === '대기' ? value : '대기';
    }

    private versionedLabel(name: string, version: string) {
        if (!version || name.toLowerCase().endsWith(version.toLowerCase())) return name;
        return name + ' ' + version;
    }

    private dateLabel(value: any) {
        if (!value) return '—';
        const text = String(value);
        const match = text.match(/^(\d{4})[-.](\d{2})[-.](\d{2})/);
        return match ? [match[1], match[2], match[3]].join('.') : text;
    }

    private dateTimeLabel(value: any) {
        return workspaceDateTime(value);
    }

    private async readResponse(response: Response) {
        try {
            return await response.json();
        } catch (error) {
            return {};
        }
    }

    private unwrapState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private responseMessage(payload: any, fallback: string) {
        return String(payload && (payload.message || payload.error && (payload.error.message || payload.error)) || fallback);
    }

    public isAdmin() {
        return this.service.auth.check.role('admin');
    }

    public visibleTasks() {
        // The workspace state API already scopes tasks to the authenticated actor.
        // Filtering again with the browser session can hide valid assignments when
        // the session payload and the persisted reviewer identity use different keys.
        return this.tasks;
    }

    public filteredTasks() {
        const query = this.keyword.trim().toLowerCase();
        const tasks = this.visibleTasks().filter((task: any) => {
            const statusMatch = this.filter === '전체' || task.status === this.filter;
            const queryMatch = !query
                || String(task.dataset || '').toLowerCase().includes(query)
                || String(task.projectName || '').toLowerCase().includes(query)
                || String(task.projectId || '').toLowerCase().includes(query)
                || String(task.survey || '').toLowerCase().includes(query)
                || String(task.reviewer || '').toLowerCase().includes(query);
            return statusMatch && queryMatch;
        });

        return tasks.slice().sort((a: any, b: any) => {
            if (this.sortMode === '진행률 높은 순') return this.taskProgress(b) - this.taskProgress(a);
            if (this.sortMode === '최근 생성 순') return String(b.created || '').localeCompare(String(a.created || ''));
            return this.dueTimestamp(a) - this.dueTimestamp(b);
        });
    }

    public qaProjects() {
        return this.projects
            .filter((project: any) => project && project.outputs && project.outputs.qa === true)
            .slice()
            .sort((a: any, b: any) => String(b.updatedAt || b.createdAt || '')
                .localeCompare(String(a.updatedAt || a.createdAt || '')));
    }

    private async loadQaReviewProjects() {
        try {
            const response = await fetch(this.qaReviewTaskUrl, {
                method: 'GET',
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { Accept: 'application/json' }
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, 'QA 프로젝트를 불러오지 못했습니다.'));
            const data = payload?.data?.data || payload?.data || payload?.result || payload;
            if (!data || !Array.isArray(data.projects)) throw new Error('QA 프로젝트 응답 형식이 올바르지 않습니다.');
            this.reviewProjects = data.projects;
            this.reviewProjectPage = 1;
            this.reviewProjectError = '';
        } catch (error) {
            this.reviewProjects = [];
            this.reviewProjectError = error instanceof Error ? error.message : 'QA 프로젝트를 불러오지 못했습니다.';
        }
    }

    public filteredReviewProjects() {
        const query = this.keyword.trim().toLowerCase();
        return this.reviewProjects.filter((project: any) => !query
            || String(project.project_name || '').toLowerCase().includes(query)
            || String(project.project_id || '').toLowerCase().includes(query)
            || String(project.survey || '').toLowerCase().includes(query));
    }

    public pagedReviewProjects() {
        const rows = this.filteredReviewProjects();
        const page = Math.min(this.reviewProjectPage, this.reviewProjectPageCount());
        const start = (page - 1) * this.reviewProjectPageSize;
        return rows.slice(start, start + this.reviewProjectPageSize);
    }

    public reviewProjectPageCount() {
        return Math.max(1, Math.ceil(this.filteredReviewProjects().length / this.reviewProjectPageSize));
    }

    public reviewProjectPageNumbers() {
        const pageCount = this.reviewProjectPageCount();
        const start = Math.max(1, Math.min(this.reviewProjectPage - 2, pageCount - 4));
        const end = Math.min(pageCount, start + 4);
        return Array.from({ length: end - start + 1 }, (_item: any, index: number) => start + index);
    }

    public resetReviewProjectPage() {
        this.reviewProjectPage = 1;
    }

    public async setReviewProjectPage(page: number) {
        const nextPage = Math.max(1, Math.min(page, this.reviewProjectPageCount()));
        if (nextPage === this.reviewProjectPage) return;
        this.reviewProjectPage = nextPage;
        await this.service.render();
    }

    public qaReviewProjectActionLabel(project: any) {
        if (project && project.review_status === 'completed') return '결과 보기';
        if (project && project.task_id) return '검수 계속';
        if (project && project.result_status === 'ready') return '검수하기';
        if (project && project.result_status === 'empty') return '검수 대상 없음';
        return 'QA 생성 필요';
    }

    public qaReviewProjectStatusClass(project: any) {
        if (project && project.review_status === 'completed') return 'is-complete';
        if (project && project.task_id) return 'is-progress';
        if (project && project.result_status === 'ready') return 'is-ready';
        return 'is-waiting';
    }

    public canStartQaReview(project: any) {
        return !!project && (
            !!project.task_id || project.result_status === 'ready'
        ) && !this.reviewProjectLoadingId;
    }

    public async startQaReview(project: any) {
        if (!project || !this.canStartQaReview(project)) {
            if (project && project.result_message) {
                await this.service.modal.warning(project.result_message, false, '확인');
            }
            return;
        }
        if (project.task_id) {
            const route = project.review_status === 'completed'
                ? '/review-results/qa/' + project.task_id
                : '/review-tasks/qa/' + project.task_id;
            this.service.href(route);
            return;
        }
        this.reviewProjectLoadingId = String(project.project_id || '');
        this.reviewProjectError = '';
        await this.service.render();
        try {
            const body = new URLSearchParams();
            body.set('payload', JSON.stringify({ project_id: project.project_id }));
            const response = await fetch(this.qaReviewTaskUrl, {
                method: 'POST',
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { Accept: 'application/json' },
                body
            });
            const payload = await this.readResponse(response);
            if (!response.ok) throw new Error(this.responseMessage(payload, 'QA 검수 작업을 준비하지 못했습니다.'));
            const data = payload?.data?.data || payload?.data || payload?.result || payload;
            const taskId = String(data && data.task && data.task.id || '');
            if (!taskId) throw new Error('QA 검수 작업 응답 형식이 올바르지 않습니다.');
            this.service.href('/review-tasks/qa/' + taskId);
        } catch (error) {
            this.reviewProjectError = error instanceof Error ? error.message : 'QA 검수 작업을 준비하지 못했습니다.';
            this.reviewProjectLoadingId = '';
            await this.service.render();
            await this.service.modal.warning(this.reviewProjectError, false, '확인');
        }
    }

    public reviewProjectUpdatedLabel(project: any) {
        return this.dateTimeLabel(project && project.updated_at);
    }

    public qaProjectRoute(project: any) {
        const projectId = String(project && project.id || '');
        return ['/review-projects', projectId, project && project.configured ? 'qa' : 'settings'];
    }

    public qaProjectStatusLabel(project: any) {
        return project && project.configured ? '설정 완료' : '설정 필요';
    }

    public qaProjectActionLabel(project: any) {
        return project && project.configured ? 'QA 화면 열기' : '설정 계속하기';
    }

    public filterCount(filter: string) {
        const tasks = this.visibleTasks();
        return filter === '전체'
            ? tasks.length
            : tasks.filter((task: any) => task.status === filter).length;
    }

    public taskRoute(task: any) {
        return '/review-tasks/qa/' + task.id;
    }

    public taskActionRoute(task: any) {
        return task && task.status === '제출 완료'
            ? '/review-results/qa/' + task.id
            : this.taskRoute(task);
    }

    public surveyRoute(task: any) {
        return '/review-surveys/qa/' + task.id;
    }

    public async setFilter(filter: string) {
        this.filter = filter;
        this.ensureSelection(this.filteredTasks());
        await this.service.render();
    }

    private restoreRouteState() {
        if (typeof window === 'undefined') return;
        const params = new URLSearchParams(window.location.search || '');
        const taskId = params.get('task') || '';
        if (params.get('view') === 'detail' && this.visibleTasks().some((task: any) => task.id === taskId)) {
            this.selectedTaskId = taskId;
            this.viewMode = 'detail';
        }
    }

    public selectedTask() {
        const tasks = this.visibleTasks();
        return tasks.find((task: any) => task.id === this.selectedTaskId)
            || this.nextActionTask()
            || tasks[0]
            || {};
    }

    public async showTaskDetail(task: any) {
        this.selectedTaskId = task && task.id || '';
        this.viewMode = 'detail';
        await this.service.render();
    }

    public async selectTask(task: any) {
        this.selectedTaskId = task && task.id || '';
        await this.service.render();
    }

    public isSelectedTask(task: any) {
        const selected = this.selectedTask();
        return !!task && !!selected && String(task.id || '') === String(selected.id || '');
    }

    public queueStatuses() {
        if (this.filter !== '전체') return [this.filter];
        return ['검수 중', '대기', '제출 완료'];
    }

    public tasksByStatus(status: string) {
        return this.filteredTasks().filter((task: any) => task.status === status);
    }

    public todayLabel() {
        const now = new Date();
        const year = now.getUTCFullYear();
        const month = String(now.getUTCMonth() + 1).padStart(2, '0');
        const day = String(now.getUTCDate()).padStart(2, '0');
        const weekday = ['일', '월', '화', '수', '목', '금', '토'][now.getUTCDay()];
        return year + '-' + month + '-' + day + ' (' + weekday + ')';
    }

    public async showTaskList() {
        this.viewMode = 'list';
        await this.service.render();
    }

    public taskActionLabel(task: any) {
        if (!task) return '검수 시작';
        if (task.assignmentPending) return 'QA 생성 대기';
        if (task.status === '제출 완료') return '결과 보기';
        if (task.status === '검수 중') return '검수 계속';
        return '검수 시작';
    }

    public taskIsPendingGeneration(task: any) {
        return !!task && task.assignmentPending === true;
    }

    public taskProgress(task: any) {
        const total = Number(task && task.sampleCount) || 0;
        return total ? (Number(task.completedCount) || 0) / total * 100 : 0;
    }

    public totalSampleCount() {
        return this.visibleTasks().reduce((sum: number, task: any) => sum + Number(task.sampleCount || 0), 0);
    }

    public totalCompletedCount() {
        return this.visibleTasks().reduce((sum: number, task: any) => sum + Number(task.completedCount || 0), 0);
    }

    public remainingSampleCount() {
        return Math.max(0, this.totalSampleCount() - this.totalCompletedCount());
    }

    public overallCompletionRate() {
        const total = this.totalSampleCount();
        return total ? Math.round(this.totalCompletedCount() / total * 100) : 0;
    }

    public nextActionTask() {
        return this.visibleTasks()
            .filter((task: any) => task.status !== '제출 완료')
            .slice()
            .sort((a: any, b: any) => this.dueTimestamp(a) - this.dueTimestamp(b))[0] || null;
    }

    private dueTimestamp(task: any) {
        const parts = String(task && task.due || '').split('.').map((value: string) => Number(value));
        if (parts.length < 3 || parts.some((value: number) => !Number.isFinite(value))) return Number.MAX_SAFE_INTEGER;
        return Date.UTC(parts[0], parts[1] - 1, parts[2]);
    }

    public daysUntilDue(task: any) {
        const due = this.dueTimestamp(task);
        if (!Number.isFinite(due) || due === Number.MAX_SAFE_INTEGER) return 999;
        const now = new Date();
        const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        return Math.ceil((due - today) / 86400000);
    }

    public dueCountdownLabel(task: any) {
        if (task && task.status === '제출 완료') return '제출 완료';
        const days = this.daysUntilDue(task);
        if (days < 0) return '기한 초과';
        if (days === 0) return '오늘 마감';
        return 'D-' + days;
    }

    public dueUrgencyClass(task: any) {
        if (task && task.status === '제출 완료') return 'is-complete';
        const days = this.daysUntilDue(task);
        if (days <= 2) return 'is-urgent';
        if (days <= 5) return 'is-near';
        return 'is-safe';
    }

    public async resetListFilters() {
        this.filter = '전체';
        this.keyword = '';
        this.sortMode = '마감 임박 순';
        this.ensureSelection();
        await this.service.render();
    }

    private ensureSelection(tasks: any[] = this.visibleTasks()) {
        if (tasks.some((task: any) => String(task.id || '') === this.selectedTaskId)) return;
        const next = tasks.find((task: any) => task.status === '검수 중')
            || tasks.find((task: any) => task.status === '대기')
            || tasks[0]
            || null;
        this.selectedTaskId = next ? String(next.id || '') : '';
    }

    public statusClass(status: string) {
        if (status === '제출 완료') return 'is-complete';
        if (status === '검수 중') return 'is-progress';
        return 'is-waiting';
    }
}

export default PageHumanReviewsComponent;